const styles = {
  title: {
    fontWeight: "bold",
    fontSize: "1rem",
    marginBottom: 2
  }
};

export default styles;
